import React from 'react';
import { Lock, Users } from 'lucide-react';

interface FolderSelectorProps {
  hasFolder: boolean;
  folderName?: string;
  onClick: (e: React.MouseEvent) => void;
  className?: string;
  ownerId?: string;
  currentUserId?: string;
}

/**
 * Shared folder selector component used in both grid and list views
 * Displays folder icon (Lock for private, Users for shared) with folder name
 * Only shows "Private" if the file is owned by the current user and has no folder
 */
export const FolderSelector: React.FC<FolderSelectorProps> = ({
  hasFolder,
  folderName,
  onClick,
  className = '',
  ownerId,
  currentUserId,
}) => {
  // Determine if file is truly private (owned by current user AND no folder)
  const isPrivate = !hasFolder && ownerId === currentUserId;

  // For shared files (not owned by current user), show "Shared" instead of folder name
  let displayText = folderName;
  if (!hasFolder) {
    displayText = isPrivate ? 'Private' : 'Shared';
  }

  return (
    <button
      type="button"
      onClick={onClick}
      className={`flex items-center gap-1 hover:text-foreground transition-colors ${className}`}
    >
      {hasFolder ? <Users className="h-3 w-3" /> : <Lock className="h-3 w-3" />}
      <span className="truncate max-w-[100px]">{displayText}</span>
    </button>
  );
};
